import { c as _c } from "react/compiler-runtime";
import type { GraphOperationUpdateSettings, PlaybookSettings } from '@onefootprint/request-types/dashboard';
import type React from 'react';
import PlaybookAppearance from './components/playbook-appearance';
import PlaybookSettingsComponent from './components/playbook-settings';
import Search from './components/search';
import useCanModernize from './use-can-modernize';
export type HeaderSlots = {
  left?: React.ReactNode;
  right?: React.ReactNode;
};
export type PlaybookGraphHeaderProps = {
  slots?: HeaderSlots;
  settings: PlaybookSettings;
  canEdit: boolean;
  onSave: (data: Omit<GraphOperationUpdateSettings, 'kind'>) => Promise<void>;
};
const PlaybookGraphHeader = t0 => {
  const $ = _c(20);
  const {
    slots,
    settings,
    canEdit,
    onSave
  } = t0;
  const canModernize = useCanModernize();
  const t1 = slots?.left;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className="flex gap-3 items-center min-w-0 overflow-hidden w-full md:w-auto">{t1}</div>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = slots?.right;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Search />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== canEdit || $[4] !== canModernize || $[5] !== onSave || $[6] !== settings) {
    t5 = (!settings.isModern || canModernize) && <PlaybookSettingsComponent onSubmit={canEdit ? onSave : undefined} playbook={settings} />;
    $[3] = canEdit;
    $[4] = canModernize;
    $[5] = onSave;
    $[6] = settings;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = canEdit ? onSave : undefined;
  const t7 = settings.appearanceId || "";
  let t8;
  if ($[8] !== t7) {
    t8 = {
      appearanceId: t7
    };
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6 || $[11] !== t8) {
    t9 = <PlaybookAppearance onSubmit={t6} defaultValues={t8} />;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t3 || $[14] !== t5 || $[15] !== t9) {
    t10 = <div className="flex flex-wrap gap-2 justify-start items-center shrink-0 w-full md:flex-nowrap md:justify-end md:w-auto">{t3}{t4}{t5}{t9}</div>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t2) {
    t11 = <header className="flex flex-wrap justify-between gap-x-3 gap-y-2 items-center z-10 flex-shrink-0 px-3 py-2 w-full border-b border-tertiary bg-primary md:flex-nowrap md:gap-3 md:py-0 md:px-4 md:h-11">{t2}{t10}</header>;
    $[17] = t10;
    $[18] = t2;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};
export default PlaybookGraphHeader;